import React from 'react'
import { Tabs, TabsProps, withStyles } from '@material-ui/core'
import clsx from 'clsx'
import { isMobile } from 'react-device-detect'

const BFTabs = withStyles(theme => ({
  root: {
    height: 40,
    display: 'flex',
    boxSizing: 'content-box',
    background: '#ffffff',
    minHeight: 'unset',
    '&.small': {
      border: '1px solid #E7ECF3',
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: 3,
      '& $indicator': {
        height: 0,
      },
      '& $button': {
        height: 40,
        fontWeight: 'normal',
      },
    },
    '&.large': {
      background: '#F8FAFC',
      overflow: 'unset',
      '& $indicator': {
        height: 10,
        background: theme.palette.primary.contrastText,
        bottom: -9,
        borderLeft: '1px solid #e7ecf3',
        width: '202.2px !important',
      },
      '& $scroller': {
        overflowY: 'hidden',
        paddingBottom: 1,
        marginBottom: '-1px !important',
      },
      '&.notSelectedTabs': {
        background: theme.palette.primary.contrastText,
        '& svg': {
          color: theme.palette.primary.light,
        },
      },
    },
  },
  indicator: {},
  scroller: {},
}))((props: ITabsProps) => {
  const { value, size, className } = props
  return (
    <Tabs
      {...props}
      className={clsx(
        size,
        value === false ? 'notSelectedTabs' : '',
        className,
      )}
      style={{
        width: 'unset',
      }}
    />
  )
})

export default BFTabs

export interface ITabsProps extends TabsProps {
  size: 'small' | 'large'
}
